import {peakAlert} from "../../PeakDialog.js";
import jQuery from "jquery";
import {ZIDXListingSummary} from "../base.js";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import {SavedListingRepository} from "../saved-listings/SavedListingRepository.js";
let $=jQuery.noConflict();

export class ZIDXHiddenListings implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxHiddenListingsContainer";
    }

    render() {
        let self=this;
        this.zidx.loadFunctions.push(() => {
            this.loadHiddenListings();
        });
    }

    async loadHiddenListings() {
        let self = this;

        // Sync with server first if logged in
        await SavedListingRepository.getInstance(this.zidx).syncWithServer();

        const obj = {
            id: "ajaxGetHiddenListings",
            method: "get",
            postObj: {},
            ignoreOldRequests: false,
            callback: (r: string) => {
                let rs = JSON.parse(r);
                if (!rs.success) {
                    console.log(rs.errorMessage);
                    const listingsContainer = $('#hiddenListingsContainer', self.zidx.peakidxShadowRoot);
                    listingsContainer.empty();
                    listingsContainer.append(`<div><p>${rs.errorMessage}</p></div>`);
                    return;
                }
                const listings: Array<ZIDXListingSummary> = JSON.parse(rs.data);

                const listingsContainer = $('#hiddenListingsContainer', self.zidx.peakidxShadowRoot);
                listingsContainer.empty();
                if (listings.length == 0) {
                    listingsContainer.append(`<div><p>You have no hidden listings</p><p><a href="${this.zidx.getPrefixURL("/")}" class="zidxButton">Search Listings</a></p></div>`);
                }
                for (let listing of listings) {
                    const link = this.zidx.zidxBase.getListingURL(listing);
                    const resultsContainer = $('<div></div>', self.zidx.peakidxShadowRoot).addClass('zidxSearchResultListingContainer zidxHiddenListingContainer');
                    resultsContainer.attr("data-id", listing.id);
                    resultsContainer.attr("data-unique-id", listing.uniqueId);
                    resultsContainer.attr("data-index-id", listing.indexId);

                    const content = this.renderListingThumbnailDetail(listing, link);
                    resultsContainer.html(content);

                    // Bind unhide button
                    resultsContainer.find('.zidxUnhideButton').on('click', (e: JQuery.ClickEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.unhideListing(listing.uniqueId, resultsContainer);
                    });

                    // Bind click to navigate to listing
                    resultsContainer.find('.zidxHiddenListingLink').on('click', (e: JQuery.ClickEvent) => {
                        e.preventDefault();
                        if (listing.address !== "Listing No Longer Available") {
                            window.location.href = link;
                        }
                    });

                    listingsContainer.append(resultsContainer);
                }
            },
            errorCallback: function (r: string) {
                console.log(r);
            },
            url: self.zidx.options.siteDomain + "/hidden-listings-api/"
        };
        this.zidx.ajaxRequest(obj);
    }

    unhideListing(uniqueId: number, container: JQuery) {
        let self = this;
        // Get listing details from container for localStorage removal
        const indexId = parseInt(container.attr("data-index-id") || "0", 10);
        const listingId = container.attr("data-id") || "";

        const obj = {
            id: "ajaxUnhideListing",
            method: "post",
            postObj: {
                listing_unique_id: uniqueId
            },
            ignoreOldRequests: false,
            callback: (r: string) => {
                let rs = JSON.parse(r);
                if (!rs.success) {
                    peakAlert(rs.errorMessage || "Failed to unhide listing");
                    return;
                }
                // Also remove from localStorage
                SavedListingRepository.getInstance(self.zidx).removeFromHidden(uniqueId, indexId, listingId);

                // Remove the listing from the UI with animation
                container.fadeOut(300, function() {
                    $(this).remove();
                    // Check if no more hidden listings
                    const remaining = $('#hiddenListingsContainer .zidxHiddenListingContainer', self.zidx.peakidxShadowRoot).length;
                    if (remaining === 0) {
                        $('#hiddenListingsContainer', self.zidx.peakidxShadowRoot).append(
                            `<div><p>You have no hidden listings</p><p><a href="${self.zidx.getPrefixURL("/")}" class="zidxButton">Search Listings</a></p></div>`
                        );
                    }
                });
            },
            errorCallback: function (r: string) {
                console.log(r);
                peakAlert("Failed to unhide listing. Please try again.");
            },
            url: self.zidx.options.siteDomain + "/contact-remove-hidden-listing/"
        };
        this.zidx.ajaxRequest(obj);
    }

    renderListingThumbnailDetail(ss: ZIDXListingSummary, link: string): string {
        let arrHTML = [];

        // Unhide button
        arrHTML.push(`<button class="zidxUnhideButton" title="Unhide this listing">X</button>`);

        // Clickable area
        arrHTML.push(`<a href="${link}" class="zidxHiddenListingLink" style="display:block; text-decoration:none; color:inherit;">`);

        arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchDetailImage");
        arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
        arrHTML.push("><span>" + this.zidx.zidxBase.htmlEditFormat("Photo of " + ss.address) + "</span></div>\n");

        arrHTML.push("<div class=\"zidxSearchDetailPrice\">");
        if (ss.price != 0) {
            arrHTML.push("$" + this.zidx.zidxBase.numberFormat(ss.price));
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailSQFT\">");
        if (ss.sqft != 0) {
            arrHTML.push(ss.sqft + " SQFT");
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailBeds\">");
        if (ss.bedrooms != 0) {
            arrHTML.push(ss.bedrooms + " Beds");
        }
        arrHTML.push("</div><div class=\"zidxSearchDetailBaths\">");
        if (ss.bathrooms != 0) {
            arrHTML.push(ss.bathrooms + " Baths");
        }
        if (ss.halfBaths != 0) {
            arrHTML.push("<br>" + ss.halfBaths + " Half Baths &nbsp; ");
        }
        arrHTML.push("</div>\n" +
            "            <div class=\"zidxSearchDetailType\">\n" +
            "            " + ss.type + "\n" +
            "        </div>\n" +
            "        <div class=\"zidxSearchDetailStatus\">\n" +
            "            " + ss.listStatus + "\n" +
            "        </div>\n" +
            "        <div class=\"zidxSearchDetailAddress\">\n" +
            "            " + ss.address + "<br>\n" +
            "        " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
            "        </div>");

        arrHTML.push("</a>");

        return arrHTML.join("");
    }
}
